import { getRequest, postRequest } from './requests';
import { ResponseToSubmit } from '../types/components/responseDialog';

const NEXT_PUBLIC_API_URL = process.env.NEXT_PUBLIC_WAGTAIL_API_URL;

export async function getResponses(formId: string) {
    const responses = await getRequest(
        `${NEXT_PUBLIC_API_URL}/v1/reactions/${formId}/`
    );
    return responses.json;
}

export async function postResponse(formId: number, formData: ResponseToSubmit) {
    const response = await postRequest(`${NEXT_PUBLIC_API_URL}/v1/reactions/`, {
        mood: formData.mood,
        name: formData.name,
        email: formData.email,
        zip_code: formData.zipCode,
        location_name: formData.locationName,
        text: formData.text,
        extra_question_answer: formData.extraQuestionAnswer,
        visible: formData.visible,
        client_name: formData.clientName,
        theme: formData.theme,
        involvement: formData.involvement,
        reaction_form: formId,
        location: formData.location,
        page_id: formData.pageId,
        sendmail: formData.sendmail,
        location_3d: formData.location3d,
        heading: formData.angle?.heading,
        tilt: formData.angle?.tilt,
        zoom: formData.angle?.zoom,
        scale: formData.angle?.scale,
        angle: formData.angle,
    });
    return response.json;
}
